import { storeName as storeDetails } from '@elab/core/store/store-details';
import { ignoreObjectProperties } from '@elab/core/utils/helpers';
import { ignorePropertiesFromStorageSync } from '@elab/core/utils/constants';
import logger from '@elab/core/utils/logger';

export const key = {
    country: 'country',
    language: 'lang',
    recentSearches: 'recentSearches',
    plpViewType: 'plpViewType',
    prepopulatedData: 'prepopulatedData',
    eGiftCardPDPLink: 'eGiftCardPDPLink',
    globalMessage: 'globalMessage',
    showGreetings: 'showGreetings',
    ppDeliveryAddress: 'ppDeliveryAddress',
    ccTraditionalDeliveryAddress: 'ccTraditionalDeliveryAddress',
    deliveryCountry: 'deliveryCountry',
    orderApiError: 'orderApiError',
    visitorId: 'visitorId',
};

export function set(key, value, stringify) {
    try {
        const data = stringify ? JSON.stringify(value) : value;
        localStorage.setItem(key, data);
    } catch (error) {
        logger.error(error);
    }
}

export function get(key, parse) {
    try {
        const data = localStorage.getItem(key);
        const value = data && parse ? JSON.parse(data) : data;

        return value || null;
    } catch (error) {
        logger.error(error);
    }
}

export function remove(key) {
    localStorage.removeItem(key);
}

export function removeEverythingExcept(...keysForSave) {
    for (const key in localStorage) {
        if (!keysForSave.includes(key)) {
            remove(key);
        }
    }
}

const stateKey = 'state';

export const loadState = () => {
    try {
        const serializedState = sessionStorage.getItem(stateKey);
        if (!serializedState) {
            return {}; // no data in the storage for first load
        }
        sessionStorage.removeItem(stateKey);
        return JSON.parse(serializedState);
    } catch (error) {
        logger.error(error);
    }
};

export const saveState = ({
    auth,
    cart,
    orders,
    search,
    global,
    ui,
    checkout,
    config,
    analytics,
    user,
    [storeDetails]: storeDetailReducer,
    wishlist,
    wishlists,
    notifyme,
    payment,
    order,
    product,
    peerius,
    address,
}) => {
    try {
        const dataToSave = ignoreObjectProperties(ignorePropertiesFromStorageSync, {
            auth,
            cart,
            orders,
            search,
            global,
            ui,
            checkout,
            config,
            analytics,
            user,
            [storeDetails]: storeDetailReducer,
            wishlist,
            wishlists,
            notifyme,
            payment,
            order,
            product,
            peerius,
            address,
        });

        const serializedState = JSON.stringify(dataToSave);
        sessionStorage.setItem(stateKey, serializedState);
    } catch (error) {
        logger.error(error);
    }
};
